<template>
  <div style="margin: 0 48px 8px 24px;">
    <el-form ref="formRef" label-position="right">
      <el-form-item label="结果反馈：">
        <el-select v-model="result" placeholder="Select" class="select-item">
          <el-option v-for="item in resultArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="审核建议：" v-if="!bitchState">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 10 }" :maxlength="100" placeholder="请输入建议（非必填）" v-model="resultMsg"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" :disabled="loading" v-loading="loading" >确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import {getSysListMenuTag, updateHygieneDetailResult} from "@/api/url";
import { phoneReg, greaterIntReg } from "@/assets/shared/reg-constant";

export default {
  name: "BannerDialog",
  props: {
    value: Object
  },
  data() {
    return {
      hygieneForm: this.value.hygieneForm,
      idArray: this.value.idArray,
      hygieneId: this.value.hygieneId,
      bitchState: this.value.bitchState,

      resultArray: [
        {label: '非常干净', value: 4},
        {label: '干净', value: 3},
        {label: '一般', value: 2},
        {label: '不合格', value: 1},
      ],
      result: 4,
      resultMsg: '',

      loading: false
    }
  },
  methods: {


    cancel() {
      this.$emit("close");
    },
    summit() {
      this.loading = true
      let param = {};
      param['idArr'] = this.idArray;
      param['hygieneId'] = this.hygieneId;
      param['result'] = this.result;
      param['resultMsg'] = this.resultMsg;
      postFormData(updateHygieneDetailResult, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.getMenuTag()
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      })
    },

    getMenuTag() {
      getFormData(getSysListMenuTag).then(data => {
        let list = data.data
        let tagList = []
        list.map(item => {
          if(item.tagNum > 0) {
            tagList.push(item.menuId)
          }
        })
        let menuList = JSON.parse(localStorage.getItem('menuList'))
        menuList.map(item => {
          if(item.children && item.children.length > 0) {
            for(let i=0; i<item.children.length; i++) {
              if(tagList.indexOf(item.children[i].id) > -1) {
                tagList.push(item.id)
                break;
              }
            }
          }
        })
        this.$store.commit('UPDATE_MENU_TAG_LIST', tagList)
      })
    },


  },
  mounted() {
    if(!this.bitchState) {
      this.result = this.hygieneForm.result?this.hygieneForm.result:4
      this.resultMsg = this.hygieneForm.resultMsg
    }
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  margin: 0 auto
}
</style>
